// oxlint-disable-next-line sellar/no-unsafe-route-params -- Route boundaries are the typed ownership point for the selected match.
import { type PathParam, useParams } from "react-router";
import type { ParameterizedRoute } from "../constants/routes";

/**
 * Parses params inherited from the router's selected match hierarchy.
 * This hook is intentionally restricted to route-boundary components.
 */
export function useSelectedRouteParams<
  Path extends string,
  Params extends Readonly<Record<string, unknown>>,
  InputParams extends Readonly<Record<string, unknown>>,
>(route: ParameterizedRoute<Path, Params, InputParams>): Params {
  const params = useParams<PathParam<Path>>();

  return route.parseParams(params as Parameters<typeof route.parseParams>[0]);
}
